import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { AgentOptionType, CollectSessionType, DeviceOptionType } from './types'

interface EditProps {
  collect_session: CollectSessionType
  agents?: AgentOptionType[]
  devices?: DeviceOptionType[]
}

export default function Edit({ collect_session, agents = [], devices = [] }: EditProps) {
  return (
    <>
      <Head title="Editing collect session" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing collect session</h1>

        <Form
          collect_session={collect_session}
          agents={agents}
          devices={devices}
          action={`/collect_sessions/${collect_session.id}`}
          method="patch"
          submitText="Mettre à jour la session de collecte"
        />

        <Link
          href={`/collect_sessions/${collect_session.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Voir cette session de collecte
        </Link>
        <Link
          href="/collect_sessions"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux sessions de collecte
        </Link>
      </div>
    </>
  )
}
